import { useSnackbar } from 'notistack';
import { useState } from 'react';
import axiosInstance from 'src/utils/axios';
import { APIS } from 'src/utils/serviceUrls';
import { SuccessStory } from '../../../@types/successStory';

export const useSuccessStories = () => {
  const [stories, setStories] = useState<SuccessStory[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentStory, setCurrentStory] = useState<SuccessStory | undefined>();
  const { enqueueSnackbar } = useSnackbar();

  const getList = async () => {
    const response = await axiosInstance.get(APIS.SUCCESS_STORIES.LIST);
    setStories(response.data.data);
  };

  const handleEditRow = (selected: SuccessStory) => {
    setCurrentStory(selected);
    setModalOpen(true);
  };

  const handleDeleteRow = async (id: string) => {
    try {
      await axiosInstance.delete(APIS.SUCCESS_STORIES.DELETE(id));
      enqueueSnackbar('Deleted Successfully', { variant: 'success' });
    } catch (error) {
      console.error(error);
      enqueueSnackbar(error?.message || 'Unable to delete story', { variant: 'error' });
    }
  };

  return {
    stories,
    modalOpen,
    setModalOpen,
    currentStory,
    setCurrentStory,
    getList,
    handleEditRow,
    handleDeleteRow,
  };
};
